//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//@core
const { FormattedText } = require('core/i18n').i18n;
//@components
const RequestMortgageTable = require('./requestMortgageTable');
// @const
const keyPrefix = 'calculateQuotaVariableMortgageTable-calculateQuotaVariableMortgageTable_';

// Add raw td because OKTableCell doesnt recognize rowSpan
const VariableMortgageTable = props => {
    const {
        isMortgageTableEnabled,
        noConditions,
        showBuildedTable,
    } = props;
    const keySufix = noConditions ? 'NoConditions' : '';

    const cellsHeaderConfiguration = [
        <span>&nbsp;</span>,
        <FormattedText value={`${keyPrefix}headerTINFirstYearFixed`}/>,
        <FormattedText value={`${keyPrefix}headerVariableTINSecondYear`}/>,
        <FormattedText value="calculateQuotaHeader-calculateQuotaHeader_TAEVariable"/>,
    ];

    const bodyValues = [
        [
            'calculateQuotaHeader-calculateQuotaHeader_financeUp50',
            'financeAllChoicesTINFirstYear',
            '50TINVariable',
            '50TAEVariable',
        ],
        [
            'calculateQuotaHeader-calculateQuotaHeader_financeUp70',
            '70TINVariable',
            '70TAEVariable'
        ],
        [
            'calculateQuotaHeader-calculateQuotaHeader_financeUp80',
            '80TINVariable',
            '80TAEVariable',
        ]
    ]

    const cellsBodyConfiguration = bodyValues.map((row) => row.map((cell, index) => ({
        asHeader: false,
        className: index === 0 ? 'mortgage-request-header-calculate-quota__table-container-variable__body__row__financial-percent' :
            "mortgage-request-header-calculate-quota__table-container-variable__body__row__value",
        value: <FormattedText value={index === 0 ? cell : `${keyPrefix}${cell}${keySufix}`}/>
    })));

    cellsBodyConfiguration[0][1]['rowSpan'] = "3";

    return (
        <RequestMortgageTable
            cellsBodyConfiguration={cellsBodyConfiguration}
            cellsHeaderConfiguration={cellsHeaderConfiguration}
            isMortgageTableEnabled={isMortgageTableEnabled}
            noConditions={noConditions}
            showBuildedTable={showBuildedTable}
            type='variable'
        ></RequestMortgageTable>
    )
}

VariableMortgageTable.propTypes = {
    isMortgageTableEnabled: PropTypes.bool.isRequired,
    noConditions: PropTypes.bool.isRequired,
    showBuildedTable: PropTypes.bool.isRequired
}

VariableMortgageTable.defaultProps = {
    showBuildedTable: false
}

module.exports = VariableMortgageTable;
